var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanetR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 665,
    height: 1030,
    viewBox: "0 0 665 1030",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_102_45)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 514.606,
    cy: 514.606,
    r: 314.606,
    fill: "url(#paint0_linear_102_45)",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_102_45",
    x: 0,
    y: 0,
    width: 1029.21,
    height: 1029.21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_102_45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_45",
    x1: 514.606,
    y1: 200,
    x2: 514.606,
    y2: 829.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E6A71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3AFA8",
    stopOpacity: 0.46
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanetR);
export default __webpack_public_path__ + "static/media/planet_r.f451971e73e8eba8b3d36b946852fa83.svg";
export { ForwardRef as ReactComponent };